import { render, staticRenderFns } from "./NewProduto.vue?vue&type=template&id=78313b09&"
import script from "./NewProduto.vue?vue&type=script&lang=js&"
export * from "./NewProduto.vue?vue&type=script&lang=js&"
import style0 from "./NewProduto.vue?vue&type=style&index=0&id=78313b09&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports